import { ValueNode } from './nodes/value-node.js';
import { GetVariableNode } from './nodes/get-variable-node.js';
/**
 * Constant-fold only cache-point value nodes whose leaves are literals / const Gets.
 * Intermediate value nodes are left uncached; the sink holds the compile-time result.
 */
export function foldConstantValueSubtrees(nodes, store) {
    const valueNodes = nodes.filter((node) => node instanceof ValueNode);
    const visiting = new Set();
    const memo = new Map();
    function isFoldable(node) {
        if (memo.has(node.id))
            return memo.get(node.id);
        if (visiting.has(node.id)) {
            memo.set(node.id, false);
            return false;
        }
        if (node.isVolatileNode()) {
            memo.set(node.id, false);
            return false;
        }
        visiting.add(node.id);
        if (node instanceof GetVariableNode) {
            const variableId = typeof node.data.variableId === 'string' ? node.data.variableId : '';
            const foldable = !!store && !!variableId && store.isConst(variableId);
            visiting.delete(node.id);
            memo.set(node.id, foldable);
            return foldable;
        }
        for (const [portKey, connections] of node.inConnections) {
            if (portKey === 'exec')
                continue;
            const upstream = connections[0]?.connectedNode;
            if (!upstream)
                continue;
            if (!(upstream instanceof ValueNode)) {
                visiting.delete(node.id);
                memo.set(node.id, false);
                return false;
            }
            if (!isFoldable(upstream)) {
                visiting.delete(node.id);
                memo.set(node.id, false);
                return false;
            }
        }
        visiting.delete(node.id);
        memo.set(node.id, true);
        return true;
    }
    for (const node of valueNodes) {
        if (!node.isCachePoint())
            continue;
        if (!isFoldable(node))
            continue;
        const outputs = node.evaluateAll();
        node.markFolded(outputs);
    }
}
